<template>
    <v-container :style="$vuetify.breakpoint.mdAndUp?'width: 90%':''">
        <v-dialog v-model="dialog" width="400" max-width="95vw">

            <v-card v-if="partnerClicked">
                <v-btn
                        style=" background-color: rgba(5, 146, 201, 1) !important; right: 5px; top: 5px"
                        fab
                        dark
                        small
                        absolute
                        right
                        top
                        @click="dialog=false"

                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-img :src="'./img/participants/'+partnerClicked.imgName" height="150px" contain
                       class="ma-auto"></v-img>
                <v-card-title class="ma-auto subtitle-2 text-center">{{partnerClicked.name}}</v-card-title>
                <v-card-text class="white overflow-y-auto" style="height: 60%; opacity: 1">
                    {{partnerClicked.description}}
                </v-card-text>
                <v-card-actions style="min-height: 30px">
                    <v-btn :href="partnerClicked.url" target="_blank" class="white--text ma-auto" dark>
                        Visiter le site internet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col
                    v-if="partners"
                    v-for="partner in partners"
                    :key="partner.name"
                    cols="6" sm="2"
            >
                <v-hover>
                    <v-card flat tile class="ma-2 elevation-5" slot-scope="{ hover }">
                        <v-img
                                :src="'./img/participants/'+partner.imgName"
                                aspect-ratio="1"
                                class="grey lighten-2 photoFrame"
                                contain
                                :alt="partner.name"
                        >
                            <v-expand-transition>
                                <v-card
                                        v-if="hover"
                                        class="transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                                        style="height: 100%;"
                                >
                                    <v-card-title class="ma-auto subtitle-2 text-center">{{partner.name}}
                                        <v-btn
                                                style=" background-color: rgba(5, 146, 201, 1) !important; right: 5px"
                                                fab
                                                dark
                                                small
                                                absolute
                                                right
                                                @click="expand(partner)"
                                                class="mr-0 pr-0"
                                                v-if="$vuetify.breakpoint.mdAndUp"
                                        >
                                            <v-icon>mdi-arrow-expand</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text v-if="$vuetify.breakpoint.mdAndUp" class="white overflow-y-auto"
                                                 style="height: 60%; opacity: 1">
                                        {{partner.description}}
                                    </v-card-text>
                                    <v-card-actions style="min-height: 30px">
                                        <v-btn :href="partner.url" target="_blank" class="white--text ma-auto" dark
                                               v-if="$vuetify.breakpoint.mdAndUp">
                                            Visiter le site internet
                                        </v-btn>
                                        <v-btn
                                                style=" background-color: rgba(5, 146, 201, 1) !important;"
                                                dark
                                                @click="expand(partner)"
                                                class="ma-auto"
                                                v-else
                                        >
                                            En savoir plus
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-expand-transition>
                        </v-img>
                    </v-card>
                </v-hover>
            </v-col>
            <v-alert v-else type="info">La liste des partenaires n'est pas encore disponible</v-alert>
            <v-col cols="6" sm="2">
                <v-hover>
                    <v-card flat tile class="ma-2 elevation-5" slot-scope="{ hover }">
                        <v-img
                                src="../../public/img/health.webp" gradient="to top right, rgba(233,153,34,.9), rgba(233,153,34,.9)"
                                aspect-ratio="1"
                                class="grey lighten-2 photoFrame"
                        >
                            <v-row class="fill-height" align-content="center" justify="center"><v-col align-self="center" class="fill-height"><div class="display-4 white--text text-center">?</div></v-col></v-row>
                            <v-expand-transition>
                                <v-card
                                        v-if="hover"
                                        class="transition-fast-in-fast-out orange darken-2 v-card--reveal white--text"
                                        style="height: 100%;"
                                >
                                    <v-card-title class="ma-auto subtitle-2 text-center">Et vous ?
                                        <v-btn
                                                style=" background-color: rgba(5, 146, 201, 1) !important; right: 5px"
                                                fab
                                                dark
                                                small
                                                absolute
                                                right
                                                :to="{name:'ourevent'}"
                                                class="mr-0 pr-0"
                                                v-if="$vuetify.breakpoint.mdAndUp"
                                        >
                                            <v-icon>mdi-arrow-expand</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-card-text v-if="$vuetify.breakpoint.mdAndUp" class="white overflow-y-auto"
                                                 style="height: 60%; opacity: 1">
                                        Rejoignez l'aventure Ludi' Health !
                                    </v-card-text>
                                    <v-card-actions style="min-height: 30px">
                                        <v-btn class="white--text ma-auto" dark
                                               v-if="$vuetify.breakpoint.mdAndUp"
                                               :to="{name:'ourevent'}">
                                            Se renseigner
                                        </v-btn>
                                        <v-btn
                                                style=" background-color: rgba(5, 146, 201, 1) !important;"
                                                dark
                                                class="ma-auto"
                                                v-else
                                        >
                                            En savoir plus
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-expand-transition>
                        </v-img>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Participant",
        data: () => {
            return {
                partners: null,
                dialog: false,
                partnerClicked: null,
            }
        },
        created() {
            axios.get('/data/participants.json').then(data => {
                this.partners = data.data;
            }).catch(e => {
                console.error(e)
            })
        },
        methods: {
            expand(partner) {
                this.partnerClicked = partner
                this.dialog = true
            }
        },
        watch: {
            dialog: function (before, after) {
                if (!this.dialog) {
                    this.partnerClicked = null
                }
            }
        }
    }
</script>

<style scoped>
    @keyframes slideInFromLeft {
        0% {
            transform: translateX(-100%);
        }
        100% {
            transform: translateX(0);
        }
    }

    .photoFrame {
        /* This section calls the slideInFromLeft animation we defined above */
        animation: 1s ease-out 0s 1 slideInFromLeft;
        background: #333;
        padding: 30px;
    }

    .v-card--reveal {
        align-items: center;
        bottom: 0;
        justify-content: center;
        opacity: .9;
        position: absolute;
        width: 100%;
        left: 0em;
        font-size: 1.5em;
        font-weight: bold;
    }

</style>